<template>
  <div v-if="data !== null">
    <Top />
    <div class="container container--mobile">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm">
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <br />
          <Pagination :numberOfDots="4" :numberOfVisitedDots="2" />
          <div class="header-wrapper margin-top-75">
            <h2 class="text-left text-primary-fh">Bekräfta/ändra ditt telefonnummer</h2>
          </div>
          <p v-html="data.screening.confirmNumberText"></p>
          <div class="phone-number-wrapper">
            <div class="phone-number-prefix">{{ prefix }}</div>
            <input
              id="phone-number-input"
              class="form-control form-control-lg form-control-block phone-number-input"
              type="text"
              name="phoneNumber"
              v-model="phoneNumber"
              :maxlength="phoneLength"
              @input="enforceNumbers()"
              @keyup.enter="verifyPhone()"
            />
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="margin-top-15"></div>
          <div class="alert alert-danger alert-validation">
            <strong>Numret kunde ej valideras, kontrollera och försök igen.</strong>
          </div>
          <alert>Något gick fel, vänligen försök igen!</alert>
          <button class="btn btn-primary btn-lg btn-block" @click="verifyPhone()" :disabled="!isLengthValid">Skicka kod</button>
          <!-- <div class="clearfix"></div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button> -->
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import Alert from '../../src/components/Alert'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'
import $ from 'jquery'

export default {
  name: 'confirm',
  components: {
    Top,
    Bottom,
    Pagination,
    Alert
  },
  props: ['visible'],
  data () {
    return {
      prefix: '+46',
      phoneLength: 9,
      phoneNumber: null,
      data: null
    }
  },
  computed: {
    isLengthValid () {
      if (this.phoneNumber && (this.phoneNumber.length === this.phoneLength)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    verifyPhone () {
      if (this.isLengthValid) {
        let loader = this.$loading.show()
        axios.postVerify(config.verifyPhoneStartUri, this.phoneNumber).then((response) => {
          if (response.status === 200) {
            loader.hide()
            sessionStorage.setItem('phone', this.phoneNumber)
            this.$router.push('entercode')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else if (error.response && error.response.status === 400) {
            loader.hide()
            $('.alert-validation').show().delay(config.msInterval).fadeOut()
          } else {
            loader.hide()
            console.log(error)
            this.$store.commit('setVisibility', true)
            setTimeout(() => this.$store.commit('setVisibility', false), config.msInterval)
          }
        })
      }
    },
    enforceNumbers () {
      this.phoneNumber = this.phoneNumber.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
      this.isLengthValid()
    }
  },
  async mounted () {
    const input = document.getElementById('phone-number-input')
    if (input) {
      input.focus()
    }
    this.data = await request({
      query: `
        {
          screening {
            confirmNumberText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#alert, .alert-validation {
  display: none;
}
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.page-item {
  color: transparent !important;
}
.margin-top-75 {
  margin-top: 75px;
}
.margin-top-15 {
  margin-top: 15px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
.phone-number-wrapper {
  display: inline-block;
  position: relative;
  font-size: 40px;
}
.phone-number-prefix {
  color: #878787;
  position: absolute;
  top: 0.25em;
  left: 0.25em;
  text-indent: 0.6em;
}
.phone-number-input {
  font-size: inherit;
  text-indent: 1.75em;
  border-radius: 0.25em;
  border: solid 1px #ccc;
  padding: 1em;
}
.phone-number-input:disabled {
  border: 0;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmNumber.vue